import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { ApolloQueryResult } from 'apollo-client';
import { Observable } from 'rxjs';

import { HttpClient } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';
import { CreateLinkInput } from '../../../shared/data/inputs/create-link.input';
import { CreateLinkQueryResponse } from '../../../shared/data/responses/create-link-query.response';
import { GetCreateLinkQuery } from '../../../shared/data/gql/query/get-create-link.query';

const axios = require('axios').default;

@Injectable({
  providedIn: 'root'
})
export class UploadService {
  constructor(private _apollo: Apollo, private _httpClient: HttpClient) {}

  getCreateLink(
    input: CreateLinkInput
  ): Observable<ApolloQueryResult<CreateLinkQueryResponse>> {
    return this._apollo.query<CreateLinkQueryResponse>({
      query: GetCreateLinkQuery,
      variables: input
    });
  }

  uploadFile(url: string, file: File): Observable<string> {
    const contentType = file.type;

    const getUploadUrl = url.split('?').shift();

    console.error(getUploadUrl);
    const options = {
      headers: {
        'Content-Type': contentType
      }
    };

    return this._httpClient.put(url, file, options).pipe(
      map(_ => getUploadUrl),
      catchError(err => 'error')
    );
    // return axios.put(url, file, options)
  }
}
